import React from "react";
import { Link } from "react-router-dom";
import dateFormat from "dateformat";
import {faImage} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import cx from "classnames";
import Icon from "../../components/Icon";
import {getInitials} from "../../utils/common";
import { useUsersContext } from "../../context/usersContext";
import {
	convertDateToUtc,
	extractDisplayMessage,
	getLeadFieldName, replaceSymbolsToHtml,
	resetUnreadCount,
	setSessionValue,
} from "../../../../Common/Appcommon";
import {faFile} from "@fortawesome/free-regular-svg-icons";

const Contact = ({ contact }) => {
	const { setUserAsUnread, getCurrentContact } = useUsersContext();

	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);
	const lastWeek = new Date(today);
	lastWeek.setDate(lastWeek.getDate() - 6);

	const ShowDate = (date) => {
		if (date.toDateString() === today.toDateString()) {
			return dateFormat(date, 'h:MM TT');
		} else if (date.toDateString() === yesterday.toDateString()) {
			return 'Yesterday';
		} else if (date > lastWeek) {
			return dateFormat(date, 'dddd');
		} else {
			return dateFormat(date, 'dd/mm/yyyy');
		}
	};

	/*const getLastMessage = () => {
		const messageDates = Object.keys(contact.messages);
		const recentMessageDate = messageDates[messageDates.length - 1];
		const messages = [...contact.messages[recentMessageDate]];
		const lastMessage = messages.pop();
		return lastMessage;
	};*/

	const getLastMessage = (contact) => {

		let res = {content : "", time : ""};

		if(contact['wsapp_recent_msg_id'] !== "" && contact['wsapp_recent_msg_id'] != null ){
			if(contact['wsapp_recent_activity'] !== '' && contact['wsapp_recent_activity'] != null){
				res['time'] = ShowDate(convertDateToUtc(contact['wsapp_recent_activity']));
			}

			if(contact['m_message'] !== "" && contact['m_message'] !== null){
				let msg = extractDisplayMessage(contact['m_type'],contact['m_components'],contact['m_message'],true);
				res['content'] = msg;
			}
		}

		return res;
	}

	const lastMessage = getLastMessage(contact);
	const contactName = "Contact_Name";//getLeadFieldName('contactname');
	let faIcon = faImage;
	if(lastMessage?.content?.type !== undefined && lastMessage?.content?.type !== 'text'){
		if(lastMessage?.content?.type === "document"){
			faIcon = faFile;
		}
	}
	const userId = getCurrentContact();

	const callUnreadCount = (contact) => {
		let contactid = contact.cid;
		setUserAsUnread(contactid);
		setSessionValue('isRefreshContacts', false);

		//if(contact.wsapp_unread_count !== 0 && contact.wsapp_unread_count !== '0'){
			//resetUnreadCount(contactid);
		//}
	}

	return (
		<Link
			className={cx("sidebar-contact",
				{'active' : (userId === contact.cid)}
			)}
			to={`/inbox/chat/${contact.cid}`}
			onClick={() => {callUnreadCount(contact)}}
		>
			<div className="sidebar-contact__avatar-wrapper">
				<span className="roundCircle">{getInitials(contact[contactName])}</span>
				{/* <img
					src={contact.profile_picture}
					alt={contact.profile_picture}
					className="avatar"
				/> */}
			</div>
			<div className="sidebar-contact__content">
				<div className="sidebar-contact__top-content">
					<h2 className="sidebar-contact__name"> {contact[contactName]} </h2>
					<span className="sidebar-contact__time">
						{/*formatTime(lastMessage.time)*/lastMessage.time}
					</span>
				</div>
				<div className="sidebar-contact__bottom-content">
					<p className="sidebar-contact__message-wrapper">
						{contact.m_type == "Out" && contact.m_status && (
							<Icon
								id={
									(contact?.m_status === "sent" || contact?.m_status === "undeliverable" || contact?.m_status === "failed") ? "singleTick" : "doubleTick"
								}
								aria-label={contact?.m_status}
								className={`sidebar-contact__message-icon ${
									contact?.m_status === "read"
										? "sidebar-contact__message-icon--blue"
										: ""
								}`}
							/>
						)}
						<span
							className={`sidebar-contact__message ${
								contact.wsapp_unread_count > 0  && userId !== contact.cid ? "sidebar-contact__message--unread" : ""
							}`}
						>
							{ lastMessage?.content?.type !== undefined && lastMessage?.content?.type !== 'text' &&
								<FontAwesomeIcon className={`sidebar-contact-msg__icons`} icon={faIcon} />
							}
							{ lastMessage?.content?.content !== undefined && lastMessage?.content?.content !== "" ? replaceSymbolsToHtml(lastMessage?.content?.content) : ""}
						</span>
					</p>
					<div className="sidebar-contact__icons">
						{contact.pinned && (
							<Icon id="pinned" className="sidebar-contact__icon" />
						)}
						{!!contact.wsapp_unread_count && contact.wsapp_unread_count > 0 && userId !== contact.cid && (
							<span className="sidebar-contact__unread">{contact.wsapp_unread_count}</span>
						)}
						{/*<button aria-label="sidebar-contact__btn">
							<Icon
								id="downArrow"
								className="sidebar-contact__icon sidebar-contact__icon--dropdown"
							/>
						</button>*/}
					</div>
				</div>
			</div>
		</Link>
	);
};

export default Contact;
